import React, { useState } from "react";
import { useDrag } from "react-dnd";
import { FaChevronDown } from "react-icons/fa";
import "./LeftsieBar.css";

const LeftSidebar = () => {
  const tools = [
    { name: "Layout", type: "DroppableLayout" },
    { name: "LineBreak", type: "DroppableLineBreak" },
    { name: "HorizontalRule", type: "DroppableHorizontalRule" },
    { name: "Text", type: "DroppableText" },
    { name: "Button", type: "DroppableButton" },
    { name: "Link", type: "DroppableLink" },
    { name: "Icon", type: "DroppableIcon" },
    { name: "List", type: "DroppableList" },
    { name: "Table", type: "DroppableTable" },
    { name: "Media", type: "DroppableMedia" },
    { name: "Input", type: "DroppableInput" },
  ];

  const DraggableTool = ({ name, type, children }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
      type: type,
      item: { name: name, type: type },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }));

    return (
      <div
        ref={drag}
        className="draggable-tool"
        style={{
          opacity: isDragging ? 0.5 : 1,
        }}
      >
        {name}
        {children}
      </div>
    );
  };

  const LayoutDropdown = () => {
    const [dropdownOpen, setDropdownOpen] = useState(true);

    return (
      <div className="dropdown">
        <button onClick={() => setDropdownOpen(!dropdownOpen)}>
          Layout
          <FaChevronDown
            style={{
              transition: "transform 0.3s",
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
        {dropdownOpen && (
          <div className="dropdown-content">
            <DraggableTool name="Div" type="DroppableDiv" />
            <DraggableTool name="Nav" type="DroppableNav" />
            <DraggableTool name="Header" type="DroppableHeader" />
            <DraggableTool name="HGroup" type="DroppableHGroup" />
            <DraggableTool name="Footer" type="DroppableFooter" />
            <DraggableTool name="Section" type="DroppableSection" />
            <DraggableTool name="Span" type="DroppableSpan" />
            <DraggableTool name="Form" type="DroppableForm" />
            <DraggableTool name="Main" type="DroppableMain" />
            <DraggableTool name="Article" type="DroppableArticle" />
            <DraggableTool name="Aside" type="DroppableAside" />
          </div>
        )}
      </div>
    );
  };

  const InputDropdown = () => {
    const [dropdownOpen, setDropdownOpen] = useState(true);

    return (
      <div className="dropdown">
        <button onClick={() => setDropdownOpen(!dropdownOpen)}>
          Input
          <FaChevronDown
            style={{
              transition: "transform 0.3s",
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
        {dropdownOpen && (
          <div className="dropdown-content">
            <DraggableTool name="Text" type="DroppableTextInput" />
            <DraggableTool name="Password" type="DroppablePasswordInput" />
            <DraggableTool name="Email" type="DroppableEmailInput" />
            <DraggableTool name="Number" type="DroppableNumberInput" />
            <DraggableTool name="Date" type="DroppableDateInput" />
            <DraggableTool name="Color" type="DroppableColorInput" />
            <DraggableTool name="Checkbox" type="DroppableCheckbox" />
            <DraggableTool name="Radio" type="DroppableRadio" />
            <DraggableTool name="File" type="DroppableFileInput" />
            <DraggableTool name="Range" type="DroppableRangeInput" />
            <DraggableTool name="DropDown" type="DroppableDropDown" />
            <DraggableTool name="Output" type="DroppableOutput" />
          </div>
        )}
      </div>
    );
  };

  const TextDropdown = () => {
    const [dropdownOpen, setDropdownOpen] = useState(true);

    return (
      <div className="dropdown">
        <button onClick={() => setDropdownOpen(!dropdownOpen)}>
          Text
          <FaChevronDown
            style={{
              transition: "transform 0.3s",
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
        {dropdownOpen && (
          <div className="dropdown-content">
            <DraggableTool name="Heading" type="DroppableHeading" />
            <DraggableTool name="Paragraph" type="DroppableParagraph" />
          </div>
        )}
      </div>
    );
  };

  const MediaDropdown = () => { 
    const [dropdownOpen, setDropdownOpen] = useState(true);

    return (
      <div className="dropdown">
        <button onClick={() => setDropdownOpen(!dropdownOpen)}>
          Media
          <FaChevronDown
            style={{
              transition: "transform 0.3s",
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />
        </button>
        {dropdownOpen && (
          <div className="dropdown-content">
            <DraggableTool name="Image" type="DroppableImage" />
            <DraggableTool name="Video" type="DroppableVideo" />
            <DraggableTool name="Audio" type="DroppableAudio" />
            <DraggableTool name="Map" type="DroppableMap" />
            <DraggableTool name="Iframe" type="DroppableIframe" />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="sidebar">
      <div>
        <h3>Tools</h3>
      </div>
      <div className="uls">
        {tools.map((tool) =>
          tool.name === "Input" ? (
            <InputDropdown key={tool.name} />
          ) : tool.name === "Text" ? (
            <TextDropdown key={tool.name} />
          ) : tool.name === "Media" ? (
            <MediaDropdown key={tool.name} />
          ) : tool.name === "Layout" ? (
            <LayoutDropdown key={tool.name} />
          ) : (
            <DraggableTool key={tool.name} name={tool.name} type={tool.type} />
          )
        )}
      </div>
    </div>
  );
};

export default LeftSidebar;
